import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7 18"
    {...props}
  >
    <path d="M.667 1 6 9 .667 17" stroke="#C2C5CC" strokeLinecap="round" />
  </svg>
);
const Memo = memo(SvgArrowRight);
export default Memo;
